import RequestHandler from '../../../../fed-resources/base/request-handler';

const HEADER_NAME = 'x-spotim-token';
const maxTokenRequests = 1;
const tokenErrors = [
  'SpotTokenIsMissingError',
  'SpotTokenNotFoundError',
  'SpotTokenExpiredError',
  'SpotTokenRevokedError',
  'SpotTokenSuspendedError',
  'SpotTokenCorruptedError'
];

function isTokenError(response) {
  return response.body && tokenErrors.indexOf(response.body.type) > -1;
}

function createRequestInterceptor(getToken) {
  return async function requestInterceptor(request) {
    var token = await getToken();
    request = request.set(HEADER_NAME, token);
    return { request };
  };
}

function createResponseInterceptor(syncToken, getToken) {
  var tokenRequestCount = 0;
  return async function responseInterceptor(request, response, options) {
    var returnValue = { response };
    if (isTokenError(response) && tokenRequestCount < maxTokenRequests) {
      let token = await getToken();
      if (request.get(HEADER_NAME) === token) {
        tokenRequestCount++;
        await syncToken();
      }
      let retryResponse = await RequestHandler.retryRequest(request, options);
      returnValue = { response: retryResponse };
    }

    return returnValue;
  };
}

export default { createRequestInterceptor, createResponseInterceptor };
